import { useEffect } from 'react';
import { useFilterCondConf } from './useFilterCondConf';
import {
  setRegionCountryDict,
  transformRegionCountryToDict,
} from '@/pages/opinion/utils/regionCountryDict';

/**
 * 将 cond 接口的 region_country 灌入运行时字典 store。
 *
 * - 复用 useFilterCondConf 的 sessionStorage 缓存（命中缓存时几乎同步返回）。
 * - 必须 needRender=true：直达/刷新场景下缓存未命中、异步请求返回后触发一次重渲染，
 *   避免「接口回来但页面不刷新、一直展示兜底」的问题。
 * - 切游戏主路径下，region_country 已在 changeStoreGameInfo 预取并写入 store，
 *   本 Hook 命中缓存，重渲染开销可忽略。
 *
 * @param gameInfo 当前游戏信息（需包含 edition_unified_id）
 */
export function useRegionCountryDict(gameInfo: any) {
  const { region_country: regionCountryList } = useFilterCondConf({
    gameInfo,
    requestList: [{ key: 'region_country', defaultValue: [] }],
    needRender: true,
  });

  useEffect(() => {
    if (regionCountryList && regionCountryList.length > 0) {
      setRegionCountryDict(transformRegionCountryToDict(regionCountryList));
    }
  }, [regionCountryList]);

  return regionCountryList;
}
